'use client';

import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

/**
 * SentryUserContext Component
 * Sets user context in Sentry for error tracking
 * Automatically updates when session changes
 */
export function SentryUserContext() {
  const { data: session } = useSession();

  useEffect(() => {
    if (session?.user) {
      // Set user context for Sentry error tracking
      Sentry.setUser({
        id: session.user.id,
        email: session.user.email || undefined,
        username: session.user.name || undefined,
      });

      // Add user feature flags as tags for better error filtering
      Sentry.setTags({
        has_mutual_fund_access: session.user.hasMutualFundAccess,
        has_commodity_access: session.user.hasCommodityAccess,
      });
    } else {
      // Clear user context when logged out
      Sentry.setUser(null);
    }
  }, [session]);

  // This component doesn't render anything
  return null;
}
